import { fromEventPattern } from 'rxjs';

export function fromDynamicEvent<T>(event: string) {
  return fromEventPattern<T>(
    (handler) => {
      return document.addEventListener(event, handler);
    },
    (_, listener) => {
      document.removeEventListener(event, listener);
    },
  );
}
